import { TimerTypes } from '../types/timers'

export type IconMeta = {
  icon?: string
  color: string
  text?: string
}
type UseIconMetaReturn = (data: TimerTypes | 'clock') => IconMeta
/**
 * Use to get icon information by a timer type.
 * @param data Timer type (break, store, etc)
 * @returns IconMeta: icon, color, text
 */
export const useIconMeta: UseIconMetaReturn = (data: TimerTypes | 'clock') => {
  switch (data) {
    case 'unknown':
      return { icon: 'add', color: 'black' }
    case 'other':
      return { icon: 'more_horiz', color: 'misc', text: 'Misc/Other' }
    case 'task':
      return { icon: 'task', color: 'secondary', text: 'Task' }
    case 'store':
      return { icon: 'store', color: 'store-visit', text: 'Store Visit' }
    case 'break':
      return { icon: 'local_cafe', color: 'break', text: 'Break' }
    case 'travel':
      return { icon: 'directions_car', color: 'travel', text: 'Travel' }
    case 'communication':
      return { icon: 'forum', color: 'communication', text: 'Communication' }
    case 'material':
      return { icon: 'inventory', color: 'material', text: 'Material Coordination' }
    case 'coupon':
      return { icon: 'receipt', color: 'coupon', text: 'Coupon Returns' }
    case 'training':
      return { icon: 'school', color: 'training', text: 'Training' }
    case 'team':
      return { icon: 'task', color: 'secondary', text: 'Team' }
    default:
      return { icon: 'timer', color: 'black', text: 'Total Time' }
  }
}
